var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "a",
    {
      staticClass: "text-sm text-primary-500 hover:text-primary-800",
      attrs: { href: _vm.phoneHref },
    },
    [_vm._v(" " + _vm._s(_vm.phone) + " ")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }